module.exports = __webpack_public_path__ + "static/main-img-services-min-1cec9f4b60f226d1798c64b6f07a05b7.png";